// Format bytes to human readable size
function formatBytes(sizeInBytes, decimalPlaces = 1, base = 1000, unit = 'KB') {
    if (sizeInBytes < 1) {
        return '0 B';
    }
    
    const exponent = Math.floor(Math.log(sizeInBytes) / Math.log(base));
    const sizeUnits = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    const suffix = [unit === 'KB' ? sizeUnits[exponent].toLowerCase() : sizeUnits[exponent], 'B'];

    if (unit === 'KiB') {
        suffix.splice(1, 0, 'i');
    }

    const formattedSize = parseFloat((sizeInBytes / Math.pow(base, exponent)).toFixed(decimalPlaces));
    return `${formattedSize} ${suffix.join('')}`.toUpperCase();
}

// Convert base64 string to Blob
function base64ToBlob(base64Content, mimetype = 'application/zip') {
    const binaryString = atob(base64Content);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimetype });
}

// Download a blob as a file
function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

// Download base64 content as a file
function downloadBase64File(base64Content, filename, mimetype = 'application/zip') {
    const blob = base64ToBlob(base64Content, mimetype);
    downloadBlob(blob, filename);
}

export default {
    formatBytes,
    base64ToBlob,
    downloadBlob,
    downloadBase64File
}